import { useParams, Link } from "react-router-dom";
import { useEffect } from "react";
import SEOHead from "@/components/feature/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { categoryMap } from "@/mocks/categories";

interface ArticleContent {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  categorySlug: string;
  date: string;
  readTime: number;
  author: string;
  tags: string[];
  imageUrl: string;
  relatedArticles: { slug: string; title: string; date: string; imageUrl: string }[];
}

const articleMap: Record<string, ArticleContent> = {
  "jm-official-entry-guide": {
    slug: "jm-official-entry-guide",
    title: "JM网页版官网入口 - 最新官方直达通道使用指南",
    excerpt: "本文详细介绍JM网页版官网入口的最新使用方式，包括如何找到官方入口、注册登录流程、以及使用过程中的注意事项，帮助您安全稳定地访问JM平台。",
    content: `<p>随着互联网技术的不断发展，越来越多的用户选择通过网页版访问JM平台，无需下载安装APP即可享受完整服务。本文将为您详细介绍<strong>JM网页版官网入口</strong>的完整使用指南。</p>

<h2>一、什么是JM网页版</h2>
<p>JM网页版是JM平台官方推出的浏览器访问版本，用户无需下载任何客户端软件，只需通过浏览器打开官方网址即可直接使用JM的全部功能。网页版与APP版本数据完全同步，且更新及时，是许多用户首选的访问方式。</p>

<h2>二、如何找到JM官方入口</h2>
<p>访问JM网页版最安全的方式是通过<strong>JM官网入口</strong>直接进入。请务必认准官方渠道，避免通过不明来源的第三方链接访问，以防止账号信息泄露或遭遇钓鱼网站。</p>
<p>官方入口特征：</p>
<ul>
  <li>网址以官方域名开头，有SSL安全证书标识</li>
  <li>页面底部有完整的版权信息和备案号</li>
  <li>登录页面有官方品牌标识</li>
  <li>支持官方客服在线验证</li>
</ul>

<h2>三、JM网页版登录步骤</h2>
<p><strong>JM网页版登录</strong>流程非常简单：</p>
<ol>
  <li>打开浏览器，访问JM官方网页版入口地址</li>
  <li>点击页面右上角的"登录"按钮</li>
  <li>输入您的注册手机号或邮箱</li>
  <li>输入密码或使用验证码登录</li>
  <li>登录成功后即可使用全部功能</li>
</ol>

<h2>四、JM网页版的优势</h2>
<h3>1. 无需下载安装</h3>
<p>JM网页版最大的优势在于无需下载APP，节省手机存储空间，随时打开浏览器即可使用。</p>
<h3>2. 跨平台兼容</h3>
<p>无论您使用的是Windows、Mac、Linux还是ChromeOS，只要有浏览器就能访问JM网页版。</p>
<h3>3. 数据实时同步</h3>
<p>JM网页版与APP端数据完全实时同步，您在网页版上的任何操作都会同步到其他设备。</p>
<h3>4. 安全稳定</h3>
<p>JM官方网页版采用先进的加密技术，确保用户数据传输和存储的安全。</p>

<h2>五、常见问题解答</h2>
<h3>JM网页版打不开怎么办？</h3>
<p>如果遇到JM网页版无法打开的情况，请尝试以下方法：清除浏览器缓存、更换网络环境、使用Chrome或Edge浏览器、检查是否为最新官方入口地址。</p>
<h3>JM网页版和APP版有什么区别？</h3>
<p>功能上两者完全一致，主要区别在于访问方式。网页版更适合偶尔使用的用户，而APP版适合高频使用者。</p>
<h3>JM网页版安全吗？</h3>
<p>只要通过<strong>JM官方入口</strong>访问，JM网页版是绝对安全的。平台采用银行级加密技术保护用户数据。</p>

<h2>六、收藏本站获取最新入口</h2>
<p>建议您将本页面加入浏览器收藏夹，以便随时获取<strong>JM最新入口</strong>地址。我们会持续更新官方认证的入口信息，确保您始终能安全稳定地访问JM平台。</p>`,
    categorySlug: "tutorial",
    date: "2026-08-08",
    readTime: 8,
    author: "JM官方团队",
    tags: ["JM网页版官网入口", "JM官网入口", "JM网页版登录", "JM官方入口"],
    imageUrl: "https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20workspace%20with%20laptop%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20clean%20aesthetic%2C%20soft%20neutral%20colors%2C%20professional%20environment%20with%20plants&width=1200&height=600&seq=art-detail-art1&orientation=landscape",
    relatedArticles: [
      { slug: "jm-web-registration-guide", title: "新手必读：JM网页版注册与首次使用完整流程", date: "2026-07-20", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel-art7&orientation=landscape" },
      { slug: "jm-web-security-handbook", title: "JM网页版安全使用完全手册：保护你的账号与隐私", date: "2026-08-01", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel-art4&orientation=landscape" },
      { slug: "jm-web-access-troubleshooting", title: "JM网页版无法访问？这里有完整的解决方案", date: "2026-08-03", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel-art3&orientation=landscape" },
    ],
  },
  "jm-latest-entry-update-august-2026": {
    slug: "jm-latest-entry-update-august-2026",
    title: "JM网页版最新入口地址更新公告（2026年8月）",
    excerpt: "JM网页版官方发布最新入口地址更新公告，确保用户能够安全稳定地访问JM平台。本文汇总了本月所有入口变更信息及使用建议。",
    content: `<p>为确保广大用户能够安全稳定地访问JM平台，JM官方定期更新和优化网页版入口地址。以下是<strong>JM最新入口</strong>地址更新公告。</p>

<h2>一、本月入口更新概览</h2>
<p>2026年8月，JM官方对网页版入口进行了以下优化：</p>
<ul>
  <li>优化了服务器负载均衡策略，访问速度提升30%</li>
  <li>新增CDN加速节点，覆盖更多地区用户</li>
  <li>升级了SSL安全证书，提升数据传输安全等级</li>
  <li>修复了部分地区用户访问缓慢的问题</li>
</ul>

<h2>二、推荐使用浏览器</h2>
<p>为了获得最佳的<strong>JM网页版</strong>使用体验，我们推荐使用以下浏览器：</p>
<ul>
  <li>Google Chrome（最新版本）</li>
  <li>Microsoft Edge（最新版本）</li>
  <li>Safari（最新版本）</li>
  <li>Firefox（最新版本）</li>
</ul>

<h2>三、版本更新内容</h2>
<h3>新增功能</h3>
<p>本次更新新增了多项实用功能，包括夜间模式、快捷键支持、页面缩放适配等，进一步提升了用户体验。</p>
<h3>性能优化</h3>
<p>页面加载速度优化、内存占用降低、动画流畅度提升，在低配置设备上也能流畅运行。</p>

<h2>四、安全提醒</h2>
<p>请用户务必通过<strong>JM官方入口</strong>访问平台，切勿使用不明来源的第三方链接。如发现可疑网站，请及时向官方客服举报。</p>`,
    categorySlug: "news",
    date: "2026-08-05",
    readTime: 6,
    author: "JM官方团队",
    tags: ["JM最新入口", "JM网页版地址", "JM入口更新"],
    imageUrl: "https://readdy.ai/api/search-image?query=Digital%20network%20connection%20concept%20with%20glowing%20nodes%20and%20links%2C%20warm%20golden%20accents%2C%20minimalist%20tech%20style%2C%20soft%20gradient%20background&width=1200&height=600&seq=art-detail-art2&orientation=landscape",
    relatedArticles: [
      { slug: "jm-official-entry-guide", title: "JM网页版官网入口 - 最新官方直达通道使用指南", date: "2026-08-08", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel-art1&orientation=landscape" },
      { slug: "jm-web-new-features-dark-mode-shortcuts", title: "JM网页版新功能深度解析：夜间模式与快捷键操作", date: "2026-07-28", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel-art5&orientation=landscape" },
      { slug: "jm-web-vs-app-comparison", title: "JM网页版与APP版功能对比：哪个更适合你？", date: "2026-07-25", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel-art6&orientation=landscape" },
    ],
  },
  "jm-web-access-troubleshooting": {
    slug: "jm-web-access-troubleshooting",
    title: "JM网页版无法访问？这里有完整的解决方案",
    excerpt: "遇到JM网页版无法访问的问题？本文整理了常见的访问故障及对应的解决方案，帮助您快速恢复JM网页版的正常使用。",
    content: `<p>本文整理了用户在使用<strong>JM网页版</strong>时常见的访问问题及解决方案，帮助您快速排查和解决问题。</p>

<h2>一、浏览器缓存问题</h2>
<p>浏览器缓存过期或损坏可能导致JM网页版无法正常加载。解决方法：</p>
<ol>
  <li>打开浏览器设置</li>
  <li>找到"清除浏览数据"选项</li>
  <li>选择"缓存的图片和文件"</li>
  <li>点击清除数据后重新访问</li>
</ol>

<h2>二、网络连接问题</h2>
<p>不稳定或受限的网络环境可能影响<strong>JM网页版登录</strong>。建议：</p>
<ul>
  <li>切换WiFi和移动数据尝试</li>
  <li>重启路由器</li>
  <li>检查是否有防火墙拦截</li>
  <li>尝试使用VPN切换网络节点</li>
</ul>

<h2>三、DNS解析问题</h2>
<p>DNS解析异常可能导致无法找到JM服务器。可以尝试：</p>
<ul>
  <li>刷新DNS缓存（命令提示符输入：ipconfig /flushdns）</li>
  <li>更换DNS服务器为公共DNS</li>
</ul>

<h2>四、浏览器兼容性</h2>
<p>请确保使用最新版本的Chrome、Edge、Safari或Firefox浏览器。过旧的浏览器版本可能不支持JM网页版的某些功能。</p>

<h2>五、联系客服</h2>
<p>如果以上方法均无法解决问题，请通过官方渠道联系JM客服获取进一步帮助。请务必通过<strong>JM直达入口</strong>访问官方客服页面。</p>`,
    categorySlug: "faq",
    date: "2026-08-03",
    readTime: 5,
    author: "JM技术支持",
    tags: ["JM网页版地址", "JM网页版登录", "JM直达入口"],
    imageUrl: "https://readdy.ai/api/search-image?query=Technical%20support%20and%20troubleshooting%20concept%2C%20clean%20workspace%20with%20laptop%20displaying%20code%2C%20warm%20lighting%2C%20modern%20minimalist%20aesthetic&width=1200&height=600&seq=art-detail-art3&orientation=landscape",
    relatedArticles: [
      { slug: "jm-web-error-codes-solutions", title: "JM网页版常见错误代码及解决方法汇总", date: "2026-07-18", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel-art8&orientation=landscape" },
      { slug: "jm-official-entry-guide", title: "JM网页版官网入口 - 最新官方直达通道使用指南", date: "2026-08-08", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel2-art1&orientation=landscape" },
      { slug: "jm-web-security-handbook", title: "JM网页版安全使用完全手册", date: "2026-08-01", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel2-art4&orientation=landscape" },
    ],
  },
  "jm-web-security-handbook": {
    slug: "jm-web-security-handbook",
    title: "JM网页版安全使用完全手册：保护你的账号与隐私",
    excerpt: "全面了解JM网页版的安全使用规范，学习如何保护账号安全、识别钓鱼网站、设置强密码等关键安全措施。",
    content: `<p>在使用<strong>JM网页版</strong>时，账号安全是最重要的。本文为您提供完整的安全使用手册。</p>

<h2>一、识别官方入口</h2>
<p>访问<strong>JM官网入口</strong>时，请确认以下安全标识：</p>
<ul>
  <li>浏览器地址栏显示锁形图标（SSL加密）</li>
  <li>网址拼写正确，无多余字符</li>
  <li>页面有完整的官方品牌元素</li>
</ul>

<h2>二、设置强密码</h2>
<p>建议密码包含以下元素：大写字母、小写字母、数字、特殊符号，长度不少于8位。定期更换密码，且不要与其他网站共用密码。</p>

<h2>三、开启双重验证</h2>
<p>JM网页版支持双重验证功能，开启后每次登录需要输入短信验证码，大大提升账号安全性。</p>

<h2>四、警惕钓鱼攻击</h2>
<p>不要点击来历不明的链接，不要向任何人透露您的账号密码和验证码。JM官方不会以任何理由要求您提供密码。</p>

<h2>五、设备管理</h2>
<p>定期检查登录设备列表，及时移除不认识的设备。在公共电脑上使用后务必退出登录。</p>

<h2>六、安全使用建议</h2>
<p>收藏<strong>JM网页版地址</strong>到浏览器书签，每次通过书签访问，避免通过搜索引擎点击广告链接进入仿冒网站。</p>`,
    categorySlug: "security",
    date: "2026-08-01",
    readTime: 7,
    author: "JM安全团队",
    tags: ["JM网页版官网入口", "JM安全指南", "JM官方入口"],
    imageUrl: "https://readdy.ai/api/search-image?query=Cyber%20security%20concept%20with%20shield%20and%20lock%20symbols%2C%20warm%20golden%20and%20teal%20accents%2C%20clean%20modern%20design&width=1200&height=600&seq=art-detail-art4&orientation=landscape",
    relatedArticles: [
      { slug: "jm-official-entry-guide", title: "JM网页版官网入口 - 最新官方直达通道使用指南", date: "2026-08-08", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel3-art1&orientation=landscape" },
      { slug: "jm-web-access-troubleshooting", title: "JM网页版无法访问？这里有完整的解决方案", date: "2026-08-03", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel3-art3&orientation=landscape" },
      { slug: "jm-web-error-codes-solutions", title: "JM网页版常见错误代码及解决方法汇总", date: "2026-07-18", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel3-art8&orientation=landscape" },
    ],
  },
  "jm-web-new-features-dark-mode-shortcuts": {
    slug: "jm-web-new-features-dark-mode-shortcuts",
    title: "JM网页版新功能深度解析：夜间模式与快捷键操作",
    excerpt: "JM网页版最新推出的夜间模式和快捷键功能详解，让您的使用体验更加舒适高效。",
    content: `<p><strong>JM网页版</strong>近期推出了多项实用新功能，本文将为您详细解析夜间模式和快捷键操作。</p>

<h2>一、夜间模式</h2>
<p>夜间模式可以有效减少屏幕蓝光对眼睛的刺激，适合在暗光环境下使用。</p>
<h3>开启方式</h3>
<ul>
  <li>点击页面右上角的设置图标</li>
  <li>选择"夜间模式"开关</li>
  <li>也可以设置为跟随系统自动切换</li>
</ul>

<h2>二、快捷键操作</h2>
<p>JM网页版支持丰富的键盘快捷键，大幅提升操作效率：</p>
<ul>
  <li>Ctrl + N：新建页面</li>
  <li>Ctrl + S：保存当前内容</li>
  <li>Ctrl + F：页面内搜索</li>
  <li>Esc：关闭当前弹窗</li>
</ul>

<h2>三、使用技巧</h2>
<p>结合夜间模式和快捷键，您可以在<strong>JM网页版登录</strong>后获得更加流畅的使用体验。建议在晚间使用时开启夜间模式保护视力。</p>`,
    categorySlug: "features",
    date: "2026-07-28",
    readTime: 4,
    author: "JM产品团队",
    tags: ["JM网页版", "JM功能解析", "JM网页版登录"],
    imageUrl: "https://readdy.ai/api/search-image?query=Dark%20mode%20laptop%20screen%20display%2C%20warm%20ambient%20lighting%2C%20modern%20minimalist%20workspace%2C%20soft%20glow%20effect&width=1200&height=600&seq=art-detail-art5&orientation=landscape",
    relatedArticles: [
      { slug: "jm-web-vs-app-comparison", title: "JM网页版与APP版功能对比：哪个更适合你？", date: "2026-07-25", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel4-art6&orientation=landscape" },
      { slug: "jm-official-entry-guide", title: "JM网页版官网入口 - 最新官方直达通道使用指南", date: "2026-08-08", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel4-art1&orientation=landscape" },
    ],
  },
  "jm-web-vs-app-comparison": {
    slug: "jm-web-vs-app-comparison",
    title: "JM网页版与APP版功能对比：哪个更适合你？",
    excerpt: "详细对比JM网页版与APP版在功能、性能、使用场景等方面的差异，帮助你选择最适合自己的访问方式。",
    content: `<p>很多用户在<strong>JM网页版</strong>和JM APP之间纠结。本文将从多个维度进行全面对比。</p>

<h2>一、功能对比</h2>
<p>JM网页版与APP版在核心功能上完全一致，包括所有主要模块和操作流程。</p>

<h2>二、性能对比</h2>
<ul>
  <li>网页版：依赖浏览器性能，在高端设备上体验流畅</li>
  <li>APP版：原生性能更优，启动速度更快</li>
</ul>

<h2>三、便捷性对比</h2>
<ul>
  <li>网页版：无需下载安装，适合偶尔使用的用户</li>
  <li>APP版：开机自启动，消息推送及时，适合高频用户</li>
</ul>

<h2>四、存储占用</h2>
<p>网页版不占用手机存储空间，对于存储空间紧张的用户非常友好。通过<strong>JM直达入口</strong>访问即可使用。</p>

<h2>五、总结</h2>
<p>如果您是轻度用户或临时需要访问，推荐使用<strong>JM网页版地址</strong>直接访问。如果您是重度用户，建议安装APP获得最佳体验。两者数据完全同步，可以随时切换。</p>`,
    categorySlug: "features",
    date: "2026-07-25",
    readTime: 5,
    author: "JM产品团队",
    tags: ["JM网页版", "JM官网入口", "JM直达入口"],
    imageUrl: "https://readdy.ai/api/search-image?query=Laptop%20and%20smartphone%20side%20by%20side%20on%20desk%2C%20warm%20natural%20lighting%2C%20minimalist%20setup%2C%20clean%20modern%20aesthetic&width=1200&height=600&seq=art-detail-art6&orientation=landscape",
    relatedArticles: [
      { slug: "jm-web-new-features-dark-mode-shortcuts", title: "JM网页版新功能深度解析：夜间模式与快捷键操作", date: "2026-07-28", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel5-art5&orientation=landscape" },
      { slug: "jm-web-registration-guide", title: "新手必读：JM网页版注册与首次使用完整流程", date: "2026-07-20", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel5-art7&orientation=landscape" },
    ],
  },
  "jm-web-registration-guide": {
    slug: "jm-web-registration-guide",
    title: "新手必读：JM网页版注册与首次使用完整流程",
    excerpt: "面向新用户的JM网页版注册与首次使用完整指南，从注册到熟悉各项功能，助你快速上手。",
    content: `<p>欢迎使用<strong>JM网页版</strong>！本指南将帮助新用户完成注册和首次使用。</p>

<h2>一、访问官方入口</h2>
<p>首先通过<strong>JM网页版官网入口</strong>打开官方页面。请认准官方标识，确保访问的是正版网站。</p>

<h2>二、注册账号</h2>
<ol>
  <li>点击页面上的"注册"按钮</li>
  <li>输入手机号码，点击获取验证码</li>
  <li>输入收到的短信验证码</li>
  <li>设置登录密码</li>
  <li>填写基本个人信息</li>
  <li>完成注册</li>
</ol>

<h2>三、首次登录</h2>
<p>注册完成后，使用手机号和密码进行<strong>JM网页版登录</strong>。首次登录建议完善个人资料并熟悉各项功能布局。</p>

<h2>四、界面导览</h2>
<p>JM网页版界面分为顶部导航栏、左侧功能菜单、中央内容区和右侧信息面板。请花几分钟时间熟悉各个功能模块的位置。</p>

<h2>五、安全设置</h2>
<p>首次使用建议立即完成安全设置：绑定邮箱、设置密保问题、开启登录保护。</p>`,
    categorySlug: "tutorial",
    date: "2026-07-20",
    readTime: 6,
    author: "JM官方团队",
    tags: ["JM网页版官网入口", "JM网页版登录", "JM注册教程"],
    imageUrl: "https://readdy.ai/api/search-image?query=Person%20typing%20on%20laptop%20keyboard%2C%20warm%20cozy%20environment%2C%20soft%20natural%20lighting%2C%20minimalist%20desk%20setup%2C%20clean%20modern%20aesthetic&width=1200&height=600&seq=art-detail-art7&orientation=landscape",
    relatedArticles: [
      { slug: "jm-official-entry-guide", title: "JM网页版官网入口 - 最新官方直达通道使用指南", date: "2026-08-08", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel6-art1&orientation=landscape" },
      { slug: "jm-web-security-handbook", title: "JM网页版安全使用完全手册", date: "2026-08-01", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel6-art4&orientation=landscape" },
    ],
  },
  "jm-web-error-codes-solutions": {
    slug: "jm-web-error-codes-solutions",
    title: "JM网页版常见错误代码及解决方法汇总",
    excerpt: "收集整理了JM网页版使用过程中常见的错误代码提示及其对应的解决方法，帮助用户快速自助排查问题。",
    content: `<p>使用<strong>JM网页版</strong>时可能会遇到一些错误提示，以下是常见错误及解决方法。</p>

<h2>常见错误代码</h2>
<ul>
  <li><strong>错误 403：</strong>访问被拒绝，请检查网络环境或清除浏览器缓存后重试</li>
  <li><strong>错误 404：</strong>页面未找到，可能是入口地址已更新，请使用<strong>JM最新入口</strong></li>
  <li><strong>错误 500：</strong>服务器内部错误，请稍后再试或联系客服</li>
  <li><strong>错误 502：</strong>网关错误，通常为服务器维护中，请耐心等待</li>
  <li><strong>超时错误：</strong>网络连接超时，请检查网络状态或切换网络</li>
</ul>

<h2>通用解决方法</h2>
<ol>
  <li>刷新页面重新尝试</li>
  <li>清除浏览器缓存和Cookie</li>
  <li>更换浏览器或使用无痕模式</li>
  <li>通过<strong>JM直达入口</strong>重新访问</li>
  <li>联系官方客服获取帮助</li>
</ol>`,
    categorySlug: "faq",
    date: "2026-07-18",
    readTime: 4,
    author: "JM技术支持",
    tags: ["JM网页版", "JM最新入口", "JM直达入口"],
    imageUrl: "https://readdy.ai/api/search-image?query=Error%20code%20display%20on%20laptop%20screen%2C%20troubleshooting%20concept%2C%20warm%20office%20lighting%2C%20clean%20minimalist%20setup&width=1200&height=600&seq=art-detail-art8&orientation=landscape",
    relatedArticles: [
      { slug: "jm-web-access-troubleshooting", title: "JM网页版无法访问？这里有完整的解决方案", date: "2026-08-03", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel7-art3&orientation=landscape" },
      { slug: "jm-web-security-handbook", title: "JM网页版安全使用完全手册", date: "2026-08-01", imageUrl: "https://readdy.ai/api/search-image?query=Clean%20modern%20workspace%2C%20warm%20lighting%2C%20minimalist%20design&width=600&height=300&seq=rel7-art4&orientation=landscape" },
    ],
  },
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [slug]);

  const article = slug ? articleMap[slug] : undefined;
  const cat = article ? categoryMap[article.categorySlug] : undefined;

  if (!article) {
    return (
      <>
        <SEOHead
          title="文章未找到"
          description="您访问的文章不存在"
          keywords="JM网页版"
          canonicalUrl={`/article/${slug}`}
        />
        <Navbar />
        <main className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-950 mb-3">
              文章未找到
            </h1>
            <Link
              to="/"
              className="text-accent-600 hover:text-accent-700 cursor-pointer"
            >
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
      </>
    );
  }

  const articleSchema = [
    {
      "@context": "https://schema.org",
      "@type": "Article",
      headline: article.title,
      description: article.excerpt,
      author: {
        "@type": "Organization",
        name: article.author,
      },
      datePublished: article.date,
      dateModified: article.date,
      url: `https://jm-official.com/article/${article.slug}`,
    },
  ];

  return (
    <>
      <SEOHead
        title={article.title}
        description={article.excerpt}
        keywords={article.tags.join(",")}
        canonicalUrl={`/article/${article.slug}`}
        ogType="article"
        schemaData={articleSchema}
      />
      <Navbar />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: "首页", href: "/" },
            cat
              ? { label: cat.name, href: `/category/${cat.slug}` }
              : undefined,
            { label: article.title },
          ].filter(Boolean) as { label: string; href?: string }[]}
        />

        <article className="py-8 md:py-12">
          <div className="w-full max-w-4xl mx-auto px-4 md:px-6 lg:px-8">
            <header className="mb-8">
              <div className="flex items-center gap-2 mb-4 flex-wrap">
                {cat && (
                  <Link
                    to={`/category/${cat.slug}`}
                    className="px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold hover:bg-accent-200 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                )}
                <span className="text-xs text-foreground-400">
                  {article.date}
                </span>
                <span className="text-xs text-foreground-400">
                  · {article.readTime}分钟阅读
                </span>
                <span className="text-xs text-foreground-400">
                  · 作者：{article.author}
                </span>
              </div>
              <h1 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-4 leading-tight">
                {article.title}
              </h1>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-2 mt-4 flex-wrap">
                {article.tags.map((tag) => (
                  <span
                    key={tag}
                    className="px-2.5 py-1 rounded-md bg-background-100 text-foreground-600 text-xs border border-background-200"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </header>

            <div className="h-56 md:h-80 w-full rounded-xl overflow-hidden mb-10">
              <img
                src={article.imageUrl}
                alt={article.title}
                className="w-full h-full object-cover object-top"
              />
            </div>

            <div
              className="prose-custom"
              dangerouslySetInnerHTML={{ __html: article.content }}
            />

            <style>{`
              .prose-custom h2 {
                font-size: 1.25rem;
                font-weight: 700;
                color: oklch(var(--foreground-950));
                margin-top: 2rem;
                margin-bottom: 0.75rem;
                padding-bottom: 0.5rem;
                border-bottom: 2px solid oklch(var(--accent-200));
              }
              .prose-custom h3 {
                font-size: 1.1rem;
                font-weight: 600;
                color: oklch(var(--foreground-800));
                margin-top: 1.5rem;
                margin-bottom: 0.5rem;
              }
              .prose-custom p {
                font-size: 0.95rem;
                line-height: 1.85;
                color: oklch(var(--foreground-600));
                margin-bottom: 1rem;
              }
              .prose-custom ul, .prose-custom ol {
                padding-left: 1.5rem;
                margin-bottom: 1rem;
              }
              .prose-custom ul li {
                list-style-type: disc;
                font-size: 0.95rem;
                line-height: 1.85;
                color: oklch(var(--foreground-600));
                margin-bottom: 0.25rem;
              }
              .prose-custom ol li {
                list-style-type: decimal;
                font-size: 0.95rem;
                line-height: 1.85;
                color: oklch(var(--foreground-600));
                margin-bottom: 0.25rem;
              }
              .prose-custom strong {
                color: oklch(var(--foreground-800));
                font-weight: 600;
              }
            `}</style>

            {article.relatedArticles.length > 0 && (
              <section className="mt-14 pt-10 border-t border-background-200">
                <h3 className="text-lg font-heading font-bold text-foreground-950 mb-6">
                  相关文章推荐
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
                  {article.relatedArticles.map((ra) => (
                    <Link
                      key={ra.slug}
                      to={`/article/${ra.slug}`}
                      className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-accent-300 transition-all duration-300 cursor-pointer"
                    >
                      <div className="h-36 w-full overflow-hidden">
                        <img
                          src={ra.imageUrl}
                          alt={ra.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-4">
                        <h4 className="text-sm font-semibold text-foreground-950 line-clamp-2 group-hover:text-accent-600 transition-colors">
                          {ra.title}
                        </h4>
                        <span className="text-xs text-foreground-400 mt-2 inline-block">
                          {ra.date}
                        </span>
                      </div>
                    </Link>
                  ))}
                </div>
              </section>
            )}
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}